 import * as React from 'react';
import * as ReactDOM from 'react-dom';


/*

    Deprectated and disabled

 */


interface ConfirmProps {
    message: String,
    description: String,
    confirmLabel: String,
    abortLabel: String,
    promise: Promise<any>

}

class Confirm extends React.Component<ConfirmProps, {}> {

    constructor(props: ConfirmProps) {
        super(props);
    }

    defaultProps = {                                                                
        confirmLabel: "Ok"
    };

    abort() {
        return Promise.reject(this.props.promise);
    }

    confirm() {
        return Promise.resolve(this.props.promise);
    }

    componentDidMount() {
        return (ReactDOM.findDOMNode(this.refs.confirm) as any).focus();
    }

    render() {
        return (
            <div className="confirm-modal">
                <div className="modal-backdrop in"> </div>
                <div className={"modal in"}
                     tabIndex={-1}
                     role={"dialog"}
                     aria-hidden={false}
                     ref={"modal"}>
                    <div className={"modal-dialog"}>
                        <div className={"modal-content"}>
                            <div className={"modal-header"}>
                                <h4 className={"modal-title"}>{this.props.message}</h4>
                                <div className={"modal-body"}>{this.props.description}</div>
                                <div className={"modal-footer"}>

                                    <div className={"text-right"}>
                                        <button className={"btn btn-default"}
                                                role={"abort"}
                                                type={"button"}
                                                onClick={this.abort}>
                                            Avbryt
                                        </button>

                                        <button className={"btn btn-primary"}
                                                role={"confirm"}
                                                type={"button"}
                                                onClick={this.confirm}
                                                ref={"confirm"}>
                                            Ok
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default function confirm(message: string, options: any) {
    let cleanup, component, props, wrapper: HTMLElement, promise;

    promise = new Promise(() => {});

    if (options == null) {
        options = {};
    }
    props = {
        message, promise, ...options
    };
    
    wrapper = document.body.appendChild(document.createElement('div'));
    component = ReactDOM.render(React.createElement(Confirm, props), wrapper);
    promise.finally(function () {
        ReactDOM.unmountComponentAtNode(wrapper);
        return setTimeout(function () {
            return wrapper.remove();
        });
    });
    return promise;
}
